// removed by extract-text-webpack-plugin
module.exports = {"clear":"PasswordPopup__clear___fVY0j","popupWrapper":"PasswordPopup__popupWrapper___2cH4P","popupContent":"PasswordPopup__popupContent___OTN6d","coll":"PasswordPopup__coll___2irMT","colr":"PasswordPopup__colr___11VFL","row":"PasswordPopup__row___3rjql","btnGroup":"PasswordPopup__btnGroup___1gHIp","btnGroupMini":"PasswordPopup__btnGroupMini___o5kXO","accent":"PasswordPopup__accent___2uyKQ"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/Start/PasswordPopup/PasswordPopup.scss
// module id = 749
// module chunks = 0